import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-sand py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-194" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-195" data-mp="30j0v1cfg4t69">
        <div className="text-center" data-id="element-196" data-mp="2vpg424c9szgk">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-forest-900 sm:text-4xl" data-id="element-197" data-mp="2voefqy68uggw">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-ink" data-id="element-198" data-mp="35fr95u7oxep1">
            Sunday at 11 p.m. Tomorrow you have mining and mineral resources class. And you're still searching for the
            best way to explain mining methods, mineral processing, and the role of mining in modern society without
            losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-muted" data-id="element-199" data-mp="1k3r3nv496tlc">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-earth-200 bg-white p-6 shadow-sm sm:p-8" data-id="element-200" data-mp="sd06sa3k0if3">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold text-forest-900" data-id="element-201" data-mp="1714szo1tfc2m">
            <AlertTriangleIcon className="h-5 w-5 text-red-700" aria-hidden="true" data-id="element-202" data-mp="1bzodrl4oahte" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-203" data-mp="3dtxbxl7jmq7k">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-204" data-mp="3hu7mzca706ta">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-700" aria-hidden="true" data-id="element-205" data-mp="p00qq6u4mh71" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-206" data-mp="y0p4r1jishjx">
          <p className="text-lg font-bold text-forest-900" data-id="element-207" data-mp="y2ib0fq80zre">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold text-earth-700 sm:text-3xl" data-id="element-208" data-mp="17xtnssi2jwwi">
            Plan your entire year today.
          </p>
        </div>
      </div>
    </section>;
}